/* eslint-disable @typescript-eslint/no-explicit-any */
import { RootState } from '@/app/store';
import { FavoriteTracksState, ITracksId } from '@/interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getFavoritesById } from '@/services/firebaseApi';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { removeDuplicate } from '@/utils/removeDuplicatesArray';

const initialState: FavoriteTracksState = {
  favoriteTracks: {
    items: []
  },
  status: {
    favoriteTracksState: 'ok'
  },
  track: {} as ITracksId
};

export const getFavoritesFirebase = createAsyncThunk(
  'getFavoritesFirebase',
  async (id: string | undefined) => {
    if (!id) return;
    const favorites = await getFavoritesById(id);
    return favorites.items;
  }
);

export const favoriteSlice = createSlice({
  name: 'favorite',
  initialState,
  reducers: {
    addFavorite: (
      state: FavoriteTracksState,
      action: PayloadAction<ITracksId>
    ) => {
      state.favoriteTracks.items = [
        ...state.favoriteTracks.items.map((item) => {
          return {
            ...item,
            isFavorite: true
          };
        }),
        action.payload
      ];
    },
    removeFavorite: (
      state: FavoriteTracksState,
      action: PayloadAction<ITracksId>
    ) => {
      state.favoriteTracks.items = state.favoriteTracks.items.filter((item) => {
        if (!item.track?.id) return item;
        return item.track.id !== action.payload.track.id;
      });
    },
    trackById: (
      state: FavoriteTracksState,
      action: PayloadAction<ITracksId>
    ) => {
      state.track = action.payload;
    },
    clearFavorite: (state: FavoriteTracksState) => {
      state.favoriteTracks.items = [];
    },
    setFavorites: (
      state: FavoriteTracksState,
      action: PayloadAction<ITracksId[]>
    ) => {
      state.favoriteTracks.items = action.payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(getFavoritesFirebase.pending, (state) => {
      state.status.favoriteTracksState = 'loading';
    });
    builder.addCase(getFavoritesFirebase.fulfilled, (state, action) => {
      const validation = action.payload.length >= 1 ? action.payload : [];

      const joinItems = [...validation, ...state.favoriteTracks.items];
      const favorites = removeDuplicate(joinItems);
      state.favoriteTracks.items = favorites;
      state.status.favoriteTracksState = 'ok';
    });
  }
});

export const {
  addFavorite,
  removeFavorite,
  trackById,
  clearFavorite,
  setFavorites
} = favoriteSlice.actions;

export const selectFavorite = (state: RootState) => state.favorite;
export default favoriteSlice.reducer;
